var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-spacer'),_c('span',{staticClass:"grey--text"},[_vm._v("©USEN CORPORATION")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }